import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createCustomFieldRequest = { field: '_customField' };
var _createCustomFieldResponse = { field: '_customField' };
var _customField = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _deleteCustomFieldRequest = {};
var _deleteCustomFieldResponse = {};
var _getCustomFieldRequest = {};
var _getCustomFieldResponse = { field: '_customField' };
var _hideCustomFieldRequest = {};
var _hideCustomFieldResponse = {};
var _listCustomFieldsRequest = {};
var _listCustomFieldsResponse = { fields: '_customField' };
var _updateCustomFieldRequest = { field: '_customField' };
var _updateCustomFieldResponse = { field: '_customField' };
var _updateCustomFieldsOrderRequest = {};
var _updateCustomFieldsOrderResponse = { fields: '_customField' };
function resolveComWixpressMembersCustomfieldsCustomFieldsUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/members/v1/custom-fields',
                destPath: '/v1/custom-fields',
            },
        ],
        _: [
            {
                srcPath: '/_api/members/v1/custom-fields',
                destPath: '/v1/custom-fields',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/members/v1/custom-fields',
                destPath: '/v1/custom-fields',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/members/v1/custom-fields',
                destPath: '/v1/custom-fields',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/members/v1/custom-fields',
                destPath: '/v1/custom-fields',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/members/v1/custom-fields',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/members/v1/custom-fields',
                destPath: '/v1/custom-fields',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a custom field. */
export function createCustomField(payload) {
    var _a = serializer(_createCustomFieldRequest, { _customField: _customField }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createCustomFieldResponse, {
        _customField: _customField,
    }).fromJSON;
    function __createCustomField(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.custom_field',
            method: 'POST',
            methodFqn: 'com.wixpress.members.customfields.CustomFields.CreateCustomField',
            url: resolveComWixpressMembersCustomfieldsCustomFieldsUrl({
                protoPath: '/v1/custom-fields',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createCustomField.fromReq = fromReq;
    __createCustomField.__isAmbassador = true;
    return __createCustomField;
}
/** Retrieves a custom field by id. */
export function getCustomField(payload) {
    var _a = serializer(_getCustomFieldRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCustomFieldResponse, {
        _customField: _customField,
    }).fromJSON;
    function __getCustomField(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.custom_field',
            method: 'GET',
            methodFqn: 'com.wixpress.members.customfields.CustomFields.GetCustomField',
            url: resolveComWixpressMembersCustomfieldsCustomFieldsUrl({
                protoPath: '/v1/custom-fields/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCustomField.fromReq = fromReq;
    __getCustomField.__isAmbassador = true;
    return __getCustomField;
}
/**
 * Returns ordered custom fields, given the provided paging.
 *
 * The fields are ordered by section in such sequence:
 * - `GENERAL`
 * - `DISPLAY_INFO`
 * - `SOCIAL`
 * The fields within same section are ordered with respect to the saved fields order.
 *
 * To modify the order of fields within sections, use [`Update Custom Fields Order`]().
 */
export function listCustomFields(payload) {
    var _a = serializer(_listCustomFieldsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listCustomFieldsResponse, {
        _customField: _customField,
    }).fromJSON;
    function __listCustomFields(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.custom_field',
            method: 'GET',
            methodFqn: 'com.wixpress.members.customfields.CustomFields.ListCustomFields',
            url: resolveComWixpressMembersCustomfieldsCustomFieldsUrl({
                protoPath: '/v1/custom-fields',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listCustomFields.fromReq = fromReq;
    __listCustomFields.__isAmbassador = true;
    return __listCustomFields;
}
/**
 * Updates a custom field.
 *
 * Allowed fields to update:
 * - when `fieldOrigin` is `CUSTOM`: `name`, `defaultPrivacy`, `socialType`.
 * - when `fieldOrigin` is `CONTACT` or `SYSTEM`: `defaultPrivacy`.
 */
export function updateCustomField(payload) {
    var _a = serializer(_updateCustomFieldRequest, { _customField: _customField }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateCustomFieldResponse, {
        _customField: _customField,
    }).fromJSON;
    function __updateCustomField(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.custom_field',
            method: 'PATCH',
            methodFqn: 'com.wixpress.members.customfields.CustomFields.UpdateCustomField',
            url: resolveComWixpressMembersCustomfieldsCustomFieldsUrl({
                protoPath: '/v1/custom-fields/{field.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateCustomField.fromReq = fromReq;
    __updateCustomField.__isAmbassador = true;
    return __updateCustomField;
}
/**
 * Deletes a custom field.
 *
 * After this action, related custom field in Contacts List will also be removed.
 */
export function deleteCustomField(payload) {
    var _a = serializer(_deleteCustomFieldRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteCustomFieldResponse, {}).fromJSON;
    function __deleteCustomField(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.custom_field',
            method: 'DELETE',
            methodFqn: 'com.wixpress.members.customfields.CustomFields.DeleteCustomField',
            url: resolveComWixpressMembersCustomfieldsCustomFieldsUrl({
                protoPath: '/v1/custom-fields/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteCustomField.fromReq = fromReq;
    __deleteCustomField.__isAmbassador = true;
    return __deleteCustomField;
}
/**
 * Hides a custom field.
 *
 * Hidden field will be removed from the members custom fields list, yet it will be available as a suggested field to be add later.
 *
 * After this action, related contacts custom field will still be available in the Contacts List.
 */
export function hideCustomField(payload) {
    var _a = serializer(_hideCustomFieldRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_hideCustomFieldResponse, {}).fromJSON;
    function __hideCustomField(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.custom_field',
            method: 'POST',
            methodFqn: 'com.wixpress.members.customfields.CustomFields.HideCustomField',
            url: resolveComWixpressMembersCustomfieldsCustomFieldsUrl({
                protoPath: '/v1/custom-fields/{id}/hide',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __hideCustomField.fromReq = fromReq;
    __hideCustomField.__isAmbassador = true;
    return __hideCustomField;
}
/** Updates custom fields order within a section. */
export function updateCustomFieldsOrder(payload) {
    var _a = serializer(_updateCustomFieldsOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateCustomFieldsOrderResponse, {
        _customField: _customField,
    }).fromJSON;
    function __updateCustomFieldsOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.custom_field',
            method: 'POST',
            methodFqn: 'com.wixpress.members.customfields.CustomFields.UpdateCustomFieldsOrder',
            url: resolveComWixpressMembersCustomfieldsCustomFieldsUrl({
                protoPath: '/v1/custom-fields/order',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateCustomFieldsOrder.fromReq = fromReq;
    __updateCustomFieldsOrder.__isAmbassador = true;
    return __updateCustomFieldsOrder;
}
//# sourceMappingURL=http.impl.js.map